import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../authProvider/authProvider";
import TableChartIcon from "@mui/icons-material/TableChart";

// import "./ThreeCards.css";

interface CardProps {
  title: string;
  content: string;
  IconComponent: React.ReactNode;
  onCardClick: () => void;
  tooltipText: string;
}

const Card: React.FC<CardProps> = ({ title, content, IconComponent, onCardClick, tooltipText }) => {
  const [hover, setHover] = useState(false);

  const cardStyle = hover ? { backgroundColor: "blue", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" } : {};

  return (
    <div className="card" onClick={onCardClick}>
      <span className="tooltip">{tooltipText}</span>
      <h2>{title}</h2>
      <div className="card-iconHome">{IconComponent}</div>
      <p>{content}</p>
    </div>
  );
};

const ThreeCards: React.FC = () => {
  const authContext = useContext(AuthContext); // Get Auth context

  const modalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      alignItems: "center",
      justifyContent: "center",
      transform: "translate(-50%, -50%)",
      width: "30%",
      height: "20%",
    },
  };

  const navigate = useNavigate();

  const hide = () => false;

  const goToForms = () => {
    navigate("/forms");
  };

  return (
    <div>
      {
        <div className="section">
          <h2 className="section-title">Forms</h2>
          <div className="cards-container">
            <Card
              title="ACH Agreement"
              content=""
              IconComponent={<TableChartIcon className="card-iconHome" />}
              onCardClick={() =>
                navigate("/forms/achAgreement", {
                  state: { formNo: "5" },
                })
              }
              tooltipText=""
            />
            <Card
              title="Agency Intake"
              content=""
              IconComponent={<TableChartIcon className="card-iconHome" />}
              onCardClick={() =>
                navigate("/forms/agentIntake", {
                  state: { formNo: "4" },
                })
              }
              tooltipText=""
            />
            <Card
              title="Contact Us"
              content=""
              IconComponent={<TableChartIcon className="card-iconHome" />}
              onCardClick={() =>
                navigate("/forms/cue", {
                  state: { formNo: "6" },
                })
              }
              tooltipText=""
            />
            {/* <Card
              title="Employee Termination"
              content=""
              IconComponent={<TableChartIcon className="card-iconHome" />}
              onCardClick={() =>
                navigate("/formBuilder", {
                  state: { formNo: "2" },
                })
              }
              tooltipText=""
            /> */}
            <Card
              title="Group Implementation Form"
              content=""
              IconComponent={<TableChartIcon className="card-iconHome" />}
              onCardClick={() =>
                navigate("/forms/gif", {
                  state: { formNo: "1" },
                })
              }
              //   onCardClick={handleClick({ formNo: '1'})}
              tooltipText=""
            />
            <Card
              title="Group Implementation Survey"
              content=""
              IconComponent={<TableChartIcon className="card-iconHome" />}
              onCardClick={() =>
                navigate("/forms/groupImplementationSurvey", {
                  state: { formNo: "7" },
                })
              }
              tooltipText=""
            />
            <Card
              title="Enrollment"
              content=""
              IconComponent={<TableChartIcon className="card-iconHome" />}
              onCardClick={() =>
                navigate("/forms/enrollment", {
                  state: { formNo: "8" },
                })
              }
              tooltipText=""
            />
            {/* <Card
              title="OptiMead Health - New Hire Form"
              content=""
              IconComponent={<TableChartIcon className="card-iconHome" />}
              onCardClick={() =>
                navigate("/formBuilder", {
                  state: { formNo: "3" },
                })
              }
              tooltipText=""
            /> */}
            {/* Coming soon */}
          </div>
        </div>
      }
    </div>
  );
};

export default ThreeCards;
